import * as React from 'react';

const SvgEditFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M20.72 2.67c-.45-.45-1.03-.67-1.61-.67-.58 0-1.17.22-1.61.67l-1.689 1.69 4.845 4.845L22.34 7.52c.89-.89.89-2.34 0-3.23l-1.62-1.62ZM14.586 5.586l4.845 4.845-7.581 7.589H7.01v-4.85l7.576-7.584Z", fill: "currentColor" }),
    React.createElement("path", { d: "M5 6.02v14h14v-7h2v9H3v-18h9v2H5Z", fill: "currentColor" })));

export { SvgEditFill as default };
